import { useEffect, useState, lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import jsCookie from 'js-cookie';
import { ChakraProvider } from '@chakra-ui/react';
import { signOutUserSuccess } from 'store/slices/userSlice';
import initialTheme from './theme/theme';
import Preloader from 'loader/Preloader';



// Lazy-loaded components
const HomePage = lazy(() => import('pages/home'));
const AuthControl = lazy(() => import('pages/auth'));

const PrivateRoute = lazy(() => import('pages/auth/PrivateRoute'));
const OwnerLayout = lazy(() => import('pages/start/layout/owner'));
const AdminLayout = lazy(() => import('./layouts/admin'));
const NoRouteFound = lazy(() => import('loader/NoRouteFound'));

export default function Main() {
  
  const dispatchRed = useDispatch();
 
  const token = jsCookie.get('token');
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  useEffect(() => {
    signOutNavigator();
  }, [token,]);

  function signOutNavigator() {
    if (!token) {
      dispatchRed(signOutUserSuccess());
      return <Navigate to="/auth/login" />;
    }
  }


  return (
    <ChakraProvider theme={currentTheme}>
      <Suspense fallback={<Preloader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<AuthControl />} />
          {/* <Route path="/user-login" element={<WorkersLoginPage />} /> */}
          <Route element={<PrivateRoute />}>
            <Route
              path="owner/*"
              element={<OwnerLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            <Route
              path="admin/*"
              element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
             <Route path="*" element={<NoRouteFound />} />
          </Route>
        </Routes>
      </Suspense>
    </ChakraProvider>
  );
}
